import {
    IAngularEvent,
    IAttributes,
    IAugmentedJQuery,
    IDirective,
    IParseService,
    IScope,
    ITimeoutService
} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";

const css = require('./bekreftKlikk.scss');

export function bekreftKlikkForInjisering() {
        return [regNavn.ng.$parse, regNavn.ng.$timeout, bekreftKlikk];
    }

    /**
     * Viser bekreftelsemelding når bruker klikker på lenken.
     * Brukes i kombinasjon med ng-click.
     *
     * Bruk: <a ng-click="handling" bekreft-klikk="bekreftelsesmelding"></a>
     */
    export function bekreftKlikk($parse:IParseService, $timeout:ITimeoutService):IDirective {
        var unik = 0; //sørger for at bekreftHandlingNavn får unik verdi

        return {
            restrict: "A",
            priority: -1, //for at dette direktivet skal evalueres før ngClick
            link: function ($scope:IScope, $element:IAugmentedJQuery, $attr:IAttributes) {
                let bekreftHandlingNavn = "bekreftKlikk" + unik++;
                let bekreftet = false;
                let opprinneligTekst;
                let opprinneligClickHandling = $parse($attr["ngClick"]);
                let kanselerBekreftTimeout = null;

                function bekreft() {
                    opprinneligTekst = $element.text();
                    $element.text($attr["bekreftKlikk"]);
                    $element.addClass("bekreftKlikk");
                    bekreftet = true;

                    kanselerBekreftTimeout = $timeout(()=> kanselerBekreft(), 50000, false);
                }

                function kanselerBekreft() {
                    $element.removeClass("bekreftKlikk");
                    $element.text(opprinneligTekst);
                    bekreftet = false;
                    $timeout.cancel(kanselerBekreftTimeout);
                }

                function utfør(event:IAngularEvent) {
                    kanselerBekreft();
                    opprinneligClickHandling($scope, {$event: event});
                }

                $scope[bekreftHandlingNavn] = (event:IAngularEvent)=> {
                    event.stopPropagation();
                    if (!bekreftet) bekreft();
                    else utfør(event);
                };

                $attr["ngClick"] = bekreftHandlingNavn + "($event)";

                //sørger for at en eventuell kanselerBekreftTimeout blir kansellert når man navigerer bort
                $scope.$on('$destroy', ()=>kanselerBekreft());
            }
        };
    }
